import { useRegions } from '@/services/api/hooks/region';
import { useResult } from '@/services/csv/useCSVService';
import { useMemo } from 'react';
import { Result } from '../steps/UploadFinanceModelStep';
import { useBuildFullRegionMap } from './useBuildFullRegionMap';

export const useGetKnownRegionsFromCsv = () => {
  const result = useResult<Result>();
  if (!result) throw Error('No result');

  const [regions] = useRegions();

  const fullRegionMap = useBuildFullRegionMap();

  return useMemo(() => {
    const reverseRegionMap: { [key: string]: string } = {};
    for (const [region, id] of Object.entries(fullRegionMap)) {
      reverseRegionMap[id] = region;
    }

    const regionsInUse = result.data[0].Pcms.map(pcm => pcm.type);
    const mappedRegionsInUse = regionsInUse.map(region => reverseRegionMap[fullRegionMap[region]] || region);

    const knownRegionCodes = regions.map(region => region.code);
    const validRegionsInUse = mappedRegionsInUse.filter(region => knownRegionCodes.includes(region));

    return validRegionsInUse;
  }, [result, regions, fullRegionMap]);
};
